import { Component, EventEmitter, Inject, Input, OnDestroy, Output } from '@angular/core';
import { AbstractControl, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { CustomerSearch } from 'projects/zbs-app/src/app/services/Ebootis.Queries/CustomerSearch';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CustomerSelectI18n } from './CustomerSelectI18n';

@Component({
	selector: 'app-customer-select',
	templateUrl: './customer-select.component.html',
	styleUrls: ['./customer-select.component.scss'],
	providers: [CustomerSelectI18n]
})
export class CustomerSelectComponent implements OnDestroy {

	@Input() set forCompany(p_forCompany: boolean) {
		this.m_forCompany = p_forCompany;
	}

	get forCompany(): boolean {
		return this.m_forCompany;
	}

	@Input() public parentForm: UntypedFormGroup;
	@Input() public displayName: string;
	@Input() public selectionMode: 'item' | 'list' | 'none';

	@Output() public customerChanged: EventEmitter<CustomerSearch.Customer[] | CustomerSearch.Customer> = new EventEmitter();

	private m_forCompany: boolean = false;
	private m_selectedCustomers: CustomerSearch.Customer[] | CustomerSearch.Customer;
	private m_subscriptionsSubject = new Subject();

	constructor(
		private m_dialog: MatDialog,
		private m_translation: CustomerSelectI18n,
		private m_fb: UntypedFormBuilder
	) { }

	/**
	 * Die Subscriptions werden geschlossen.
	 */
	public ngOnDestroy(): void {
		this.m_subscriptionsSubject.next(null);
		this.m_subscriptionsSubject.complete();
	}

	set SelectedCustomer(p_value: CustomerSearch.Customer[] | CustomerSearch.Customer) {
		this.m_selectedCustomers = p_value;
		if (this.m_selectedCustomers instanceof Array) {
			this.displayName = this.m_selectedCustomers.length + ' ' + this.m_translation.customerSelectCustomers;
			const ctrl = (this.getControl() as UntypedFormArray);
			if (ctrl)
				ctrl.clear();
			if (this.parentForm)
				this.m_selectedCustomers.forEach((customer) => {
					(this.getControl() as UntypedFormArray).push(this.m_fb.control(customer ? customer.oid : ''));
				});
		} else {
			if (this.m_selectedCustomers) {
				let name: string = this.addStringIfNotEmpty(this.m_selectedCustomers.id);
				if (this.m_selectedCustomers.companyName1 || this.m_selectedCustomers.companyName2) {
					name += this.addStringIfNotEmpty(this.m_selectedCustomers.companyName1);
					name += this.addStringIfNotEmpty(this.m_selectedCustomers.companyName2);
				} else {
					name = this.addStringIfNotEmpty(this.m_selectedCustomers.title);
					name += this.addStringIfNotEmpty(this.m_selectedCustomers.firstName);
					name += this.addStringIfNotEmpty(this.m_selectedCustomers.lastName);
				}
				this.displayName = name;
			}
			if (this.parentForm) {
				this.getControl().setValue(this.m_selectedCustomers ? this.m_selectedCustomers.oid : '');
			}
		}
		this.customerChanged.emit(this.m_selectedCustomers);
	}

	/**Wenn ein Value vorhanden ist, wird er mit einem angehangen Leerzeichen zurückgegeben, ansonsten ein leerer String */
	private addStringIfNotEmpty(p_value: string): string {
		let stringToAdd: string = p_value ? (p_value + ' ') : '';
		return stringToAdd;
	}

	get SelectedCustomer(): CustomerSearch.Customer[] | CustomerSearch.Customer {
		return this.m_selectedCustomers;
	}

	/**
	 * Modaler Dialog wird aufgerufen. Ausgewählter Article wird zurückgegeben.
	 */
	public openDialog_Click(): void {
		const dialogRef = this.m_dialog.open(CustomerDialog, {
			minWidth: '100%',
			maxWidth: '100%',
			minHeight: '100%',
			maxHeight: '100%',
			data: {
				customer: this.m_selectedCustomers,
				selectionMode: this.selectionMode,
				forCompany: this.forCompany
			}
		});

		dialogRef.afterClosed().pipe(
			takeUntil(this.m_subscriptionsSubject)
		).subscribe({
			next: (result) => {
				this.SelectedCustomer = result;
			}
		});
	}

	/**
	 * Setzt Inhalt des FormControl auf undefined.
	 */
	public clearInput_Click(): void {
		this.getControl().setValue('');
		this.displayName = '';
		this.customerChanged.emit(undefined);
	}

	/**
	 * Gibt das aktuelle FormControl zurück.
	 */
	public getControl(): AbstractControl {
		return this.parentForm ? this.parentForm.get('customer') : null;
	}

	/**
	 * Prüft ob das aktuelle FormControl ein Pflichtfeld ist.
	 */
	public isRequiredField(): boolean {
		const form_field = this.getControl();
		if (!form_field || !form_field.validator) {
			return false;
		} else {
			const validator = form_field.validator({} as AbstractControl);
			return (validator && validator.required);
		}
	}
}

@Component({
	selector: 'customer-select-dialog',
	templateUrl: 'customer-select-dialog.html',
})
export class CustomerDialog {

	constructor(
		public m_dialogRef: MatDialogRef<CustomerDialog>,
		@Inject(MAT_DIALOG_DATA) public m_customerSelectData
	) {
	}

	/**
	 * Ein ausgewählter Customer wird auf den Aufrufer des Dialoges zurückgegeben.
	 * @param p_customers Ausgewählter Customer
	 */
	public selectedCustomers(p_customers: CustomerSearch.Customer | CustomerSearch.Customer[]) {
		this.m_dialogRef.close(p_customers);
	}

	/**
	 * Der modale Dialog wird geschlossen.
	 */
	public closeDialog_Click(): void {
		this.m_dialogRef.close();
	}

}
